import {
  MDBBtnGroup,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
} from "mdb-react-ui-kit";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLoaderNew from "../views/popups/PopupLoaderNew";
import ResendWelcomeEmail from "../views/popups/users/MultiSelect/ResendWelcomeEmail";
import AddtoUserGroup from "../views/popups/users/MultiSelect/AddtoUserGroup";
import AddWIEvents from "../views/popups/users/AddWIEvents";
import ChangePermissionRole from "../views/popups/users/MultiSelect/ChangePermissionRole";
import ChangeSeatPlan from "../views/popups/users/MultiSelect/ChangeSeatPlan";
import EnableAddOn from "../views/popups/users/MultiSelect/EnableAddOn";
import ChangeBillingGroup from "../views/popups/users/MultiSelect/BillingGroup";
import ChangeLocation from "../views/popups/users/MultiSelect/ChangeLocation";
import CallingPermissions from "../views/popups/users/MultiSelect/CallingPermissions";
import ChangeCallerId from "../views/popups/users/MultiSelect/CallerId";
import ResetPassword from "../views/popups/users/MultiSelect/ResetPassword";
import PopupLoader from "../views/popups/PopupLoader";
import { createPortal } from "react-dom";
import { getImpExpStatusNew } from "./CommonUtils";
import ImportProgressWarning from "./ImportProgressWarning";
import ImpExpRedirectPopup from "./ImpExpRedirectPopup";
import ImportUser from "../components/editviews/user/ImportUser";

function CommonMoreOptions({
  DropDownitem,
  disableMulti,
  agentList,
  locUser,
  groupInfo,
  groupUInfo,
  moduleType,
  usergroups,
  userLoc,
  userAllgroups,
  moduleid,
  showWarning,
  onImpExpRedirect,
  onImpExpWarning,
}) {
  const [iscallerid, setiscallerid] = useState(false);
  const toggleCallerid = () => setiscallerid(!iscallerid);
  const [ChangeCallingPermissions, setChangeCallingPermissions] =
    useState(false);
  const toggleChangeCallingPermissions = () =>
    setChangeCallingPermissions(!ChangeCallingPermissions);
  const [isLocation, setIsLocation] = useState(false);
  const toggleLocation = () => setIsLocation(!isLocation);
  const [isBillingGroup, setIsBillingGroup] = useState(false);
  const toggleBillingGroup = () => setIsBillingGroup(!isBillingGroup);
  const [isAddons, setIsAddons] = useState(false);
  const toggleAddons = () => setIsAddons(!isAddons);
  const [isSeatPlan, setisSeatPlan] = useState(false);
  const toggleSeatsPlans = () => setisSeatPlan(!isSeatPlan);
  const [isPermissionRole, setIsPermissionRole] = useState(false);
  const togglePermissionRole = () => setIsPermissionRole(!isPermissionRole);
  const [isWebIntegration, setisWebIntegration] = useState(false);
  const toggleWebIntegration = () => setisWebIntegration(!isWebIntegration);
  const [isAddGroup, setIsAddGroup] = useState(false);
  const toggleAddGroup = () => setIsAddGroup(!isAddGroup);
  const [isResetPasswords, setIsResetPasswords] = useState(false);
  const toggleResetPasswords = () => setIsResetPasswords(!isResetPasswords);
  const [isResendEmails, setisResendEmails] = useState(false);
  const toggleResendEmails = () => setisResendEmails(!isResendEmails);
  const [isLoading, setisLoading] = useState(false);
  const addUserRef = useRef(null);
  const [showDropDown, setshowDropDown] = useState(false);
  const { t } = useTranslation();
  const [showLocalWarning, setShowLocalWarning] = useState(false);
  const localWarningToggle = () => setShowLocalWarning(!showLocalWarning);
  const [warningMessage, setWarningMessage] = useState("");

  // NEW: state for redirect popup (isOwnUser case)
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);

  function handleClick() {
    addUserRef.current.click();
  }

  const toggleActions = {
    "caller-id": toggleCallerid,
    location: toggleLocation,
    "billing-group": toggleBillingGroup,
    addons: toggleAddons,
    "seat-plan": toggleSeatsPlans,
    "permission-role": togglePermissionRole,
    "web-integration": toggleWebIntegration,
    "add-group": toggleAddGroup,
    "reset-password": toggleResetPasswords,
    "resend-email": toggleResendEmails,
  };

  function enableToggle(e, key) {
    e.preventDefault();
    if (toggleActions[key]) {
      toggleActions[key]();
    }
  }

  const portalTarget = document.getElementById(moduleid);

  // Render all popups through portal
  const renderPortalContent = () => {
    if (!portalTarget) return null;

    return createPortal(
      <>
        {iscallerid && (
          <PopupLoaderNew
            title={"Change Caller ID"}
            content={
              <ChangeCallerId
                onClose={toggleCallerid}
                agentList={agentList}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                ref={addUserRef}
                setIsloading={setisLoading}
                moduleType={moduleType}
              />
            }
            onShow={setiscallerid}
            onClose={toggleCallerid}
            onSave={handleClick}
            isloading={isLoading}
            flag={5}
          />
        )}

        {ChangeCallingPermissions && (
          <PopupLoaderNew
            title={"Change Calling Permissions"}
            content={
              <CallingPermissions
                onClose={toggleChangeCallingPermissions}
                agentList={agentList}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                ref={addUserRef}
                setIsloading={setisLoading}
                moduleType={moduleType}
              />
            }
            onShow={setChangeCallingPermissions}
            onClose={toggleChangeCallingPermissions}
            onSave={handleClick}
            isloading={isLoading}
            flag={5}
          />
        )}

        {isLocation && (
          <PopupLoaderNew
            title={"Change Location"}
            content={
              <ChangeLocation
                onClose={toggleLocation}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                agentList={agentList}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                ref={addUserRef}
                setIsloading={setisLoading}
                moduleType={moduleType}
              />
            }
            onShow={setIsLocation}
            onClose={toggleLocation}
            onSave={handleClick}
            isloading={isLoading}
            flag={5}
          />
        )}

        {isBillingGroup && (
          <PopupLoaderNew
            title={"Change Billing Group"}
            content={
              <ChangeBillingGroup
                onClose={toggleBillingGroup}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                agentList={agentList}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                ref={addUserRef}
                setIsloading={setisLoading}
                moduleType={moduleType}
              />
            }
            onShow={setIsBillingGroup}
            onClose={toggleBillingGroup}
            onSave={handleClick}
            isloading={isLoading}
            flag={5}
          />
        )}

        {isAddons && (
          <PopupLoaderNew
            title={"Enable Disable Addons"}
            content={
              <EnableAddOn
                onClose={toggleAddons}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                agentList={agentList}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                ref={addUserRef}
                setIsloading={setisLoading}
                moduleType={moduleType}
              />
            }
            onShow={setIsAddons}
            onClose={toggleAddons}
            onSave={handleClick}
            isloading={isLoading}
            flag={5}
          />
        )}

        {isSeatPlan && (
          <PopupLoaderNew
            title={"Change Seat Plan"}
            content={
              <ChangeSeatPlan
                onClose={toggleSeatsPlans}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                agentList={agentList}
                ref={addUserRef}
                setIsloading={setisLoading}
                moduleType={moduleType}
              />
            }
            onShow={setisSeatPlan}
            onClose={toggleSeatsPlans}
            onSave={handleClick}
            isloading={isLoading}
            flag={5}
          />
        )}

        {isPermissionRole && (
          <PopupLoaderNew
            title={"Change Permission Role"}
            content={
              <ChangePermissionRole
                onClose={togglePermissionRole}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                agentList={agentList}
                ref={addUserRef}
                setIsloading={setisLoading}
                moduleType={moduleType}
              />
            }
            onShow={setIsPermissionRole}
            onClose={togglePermissionRole}
            onSave={handleClick}
            isloading={isLoading}
            flag={5}
          />
        )}

        {isWebIntegration && (
          <PopupLoader
            title={"Configure Web Integration"}
            content={
              <AddWIEvents
                eventDetails={{}}
                useragent={null}
                setSuccessMessage={null}
                setnewEventObj={{}}
                setisAdd={null}
                setisEdit={null}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                agentList={agentList}
                onClose={toggleWebIntegration}
                moduleType={moduleType}
              />
            }
            onShow={setisWebIntegration}
            onClose={toggleWebIntegration}
          />
        )}

        {isAddGroup && (
          <PopupLoaderNew
            title={"Add to a Group"}
            content={
              <AddtoUserGroup
                onClose={toggleAddGroup}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                agentList={agentList}
                ref={addUserRef}
                setIsloading={setisLoading}
                moduleType={moduleType}
              />
            }
            onShow={setIsAddGroup}
            onClose={toggleAddGroup}
            onSave={handleClick}
            isloading={isLoading}
            flag={1}
          />
        )}

        {isResetPasswords && (
          <PopupLoaderNew
            title={"Reset Password"}
            content={
              <ResetPassword
                onClose={toggleResetPasswords}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                agentList={agentList}
                ref={addUserRef}
                setIsloading={setisLoading}
                moduleType={moduleType}
              />
            }
            onShow={setIsResetPasswords}
            onClose={toggleResetPasswords}
            onSave={handleClick}
            isloading={isLoading}
            flag={6}
          />
        )}

        {isResendEmails && (
          <PopupLoaderNew
            title={"Resend Welcome Email"}
            content={
              <ResendWelcomeEmail
                onClose={toggleResendEmails}
                locUser={locUser ?? null}
                groupInfo={groupInfo ?? null}
                groupUInfo={groupUInfo ?? null}
                usergroups={usergroups}
                userLoc={userLoc}
                userAllgroups={userAllgroups}
                agentList={agentList}
                ref={addUserRef}
                setIsloading={setisLoading}
                moduleType={moduleType}
              />
            }
            onShow={setisResendEmails}
            onClose={toggleResendEmails}
            onSave={handleClick}
            isloading={isLoading}
            flag={7}
          />
        )}
      </>,
      portalTarget
    );
  };

  // UPDATED: now handles all 3 cases matching Users.js handleforImpExp logic
  const handleforImpExp = async () => {
    if (showWarning) {
      const result = await getImpExpStatusNew();

      if (result.status === 0) {
        // Case 0: no operation in progress — open dropdown normally
        setshowDropDown(true);
      } else if (result.isOwnUser) {
        // Case 1: own user initiated — delegate to parent if callback provided, else show locally
        setshowDropDown(false);
        if (onImpExpRedirect) {
          onImpExpRedirect();
        } else {
          setShowImpExpRedirect(true);
        }
      } else {
        // Case 2: another user/account initiated — delegate to parent if callback provided, else show locally
        setshowDropDown(false);
        const { userInfo } = result;
        const msg = userInfo?.isaccount
          ? t("imp_exp_account_progress", { name: userInfo.name ?? "" })
          : t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" });
        if (onImpExpWarning) {
          onImpExpWarning(msg);
        } else {
          setWarningMessage(msg);
          setShowLocalWarning(true);
        }
      }
    } else {
      setshowDropDown(true);
    }
  };

  return (
    <>
      <MDBBtnGroup
        aria-label="Button group with nested dropdown"
        className="display-inline ms-3 btn_adjust h-inherit"
      >
        <MDBBtnGroup>
          <MDBDropdown>
            <MDBDropdownToggle
              className="px-3"
              disabled={disableMulti}
              onClick={handleforImpExp}
            >
              <div className="text-white">
                <MDBIcon fas icon="ellipsis-v" className="me-2" />
                More
              </div>
            </MDBDropdownToggle>
            {showDropDown && (
              <>
                <MDBDropdownMenu>
                  {DropDownitem.filter((item) => item.show !== false)
                    .map((item) => (
                      <MDBDropdownItem
                        onClick={(e) => enableToggle(e, item.key)}
                        link
                        key={item.key}
                      >
                        {item.label}
                      </MDBDropdownItem>
                    ))}
                </MDBDropdownMenu>
              </>
            )}
          </MDBDropdown>
        </MDBBtnGroup>
      </MDBBtnGroup>

      {renderPortalContent()}

      {showLocalWarning && (
        <ImportProgressWarning
          warningToggle={localWarningToggle}
          setShowWarning={setShowLocalWarning}
          onOk={localWarningToggle}
          message={warningMessage}
        />
      )}

      {/* NEW: Redirect popup for isOwnUser case — on Proceed, open the dropdown */}
      {showImpExpRedirect && (
        <ImpExpRedirectPopup
          onProceed={() => {
            setShowImpExpRedirect(false);
            setshowDropDown(true);
          }}
          onCancel={() => setShowImpExpRedirect(false)}
        />
      )}
    </>
  );
}

export default CommonMoreOptions;